import { RootState } from "@store/reducers";
import { useState } from "react";
import { useSelector } from "react-redux";
import dayjs from "@lib/dayjs";
import VerifiedIcon from "@assets/svg/VerifiedIcon";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useSnackbar } from "notistack";
import CopyIcon from "@assets/svg/CopyIcon";

const tabs = [
  {
    label: "About",
  },
  {
    label: "Messages",
  },
  {
    label: "Tracker",
  },
];

const Profile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const user = useSelector((state: RootState) => state?.auth?.user);
  const [activeTab, setActiveTab] = useState("About");

  return (
    <div className="flex flex-col rounded-md w-full flex-1 bg-white py-12 px-20 gap-8">
      {/* Top container */}
      <div className="flex items-center border rounded-lg py-8 px-14 gap-8">
        {user?.profilePic ? (
          <img
            className="border rounded-full h-40 w-40"
            src={user?.profilePic}
          />
        ) : (
          <div className="flex items-center justify-center text-6xl text-gray-500 font-bold h-40 w-40 bg-gray-100 border rounded-full">
            {user?.firstName?.charAt(0)}
            {user?.lastName?.charAt(0)}
          </div>
        )}
        <div className="flex flex-col">
          <div className="flex flex-col gap-2">
            <div className="flex items-cneter gap-2 text-primary font-medium text-sm">
              <VerifiedIcon />
              Verified
            </div>
            <span className="font-bold text-sm text-primary">
              {user?.firstName} {user?.lastName}
            </span>
            <div className="flex items-center">
              <span className="text-xs text-primary font-semibold w-24">
                Username:
              </span>
              <span className="text-xs text-light-black font-medium">
                {user?.userName}
              </span>
            </div>
            <div className="flex items-center">
              <span className="text-xs text-primary font-semibold w-24">
                Profile:
              </span>
              <div className="flex items-center gap-2">
                <a
                  href={`https://comtracked/profile/${user?.userName}`}
                  className="text-xs text-light-black font-medium"
                >
                  https://comtracked/profile/{user?.userName}
                </a>
                <CopyToClipboard
                  text={`https://comtracked/profile/${user?.userName}`}
                  onCopy={() =>
                    enqueueSnackbar("Link copied successfully.", {
                      variant: "success",
                    })
                  }
                >
                  <button className="h-6 w-6 rounded-sm hover:bg-gray-100 flex items-center justify-center">
                    <CopyIcon className={"w-3 h-3"} fill="gray" />
                  </button>
                </CopyToClipboard>
              </div>
            </div>
            <div className="flex items-center">
              <span className="text-xs text-primary font-semibold w-24">
                Joined:
              </span>
              <span className="text-xs text-light-black font-medium">
                Joined {dayjs(user?.createdAt).format("D MMM YYYY")}
              </span>
            </div>
          </div>
          <span className="text-xs font-medium text-light-black mt-5">
            You joined my referral network{" "}
            {dayjs(user?.createdAt).format("D MMM YYYY")}
          </span>
        </div>
      </div>
      {/* Tab container */}
      <div className="flex items-center border-b gap-12 px-16 pb-1">
        {tabs?.map((tab) => {
          const isActive = tab?.label === activeTab;
          return (
            <button
              key={tab?.label}
              onClick={() => setActiveTab(tab?.label)}
              className={`text-xs font-medium ${
                isActive
                  ? "border-b border-primary text-primary"
                  : "text-gray-400"
              }`}
            >
              {tab?.label}
            </button>
          );
        })}
      </div>
      {/* Main container */}
      <div className="flex flex-col border rounded-lg py-12 px-16 gap-4">
        <span className="font-semibold text-xs text-primary">About Me:</span>
        <span className="font-medium text-xs text-primary leading-5">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum
          dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
          incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
          quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea
          commodo consequat.{" "}
        </span>
      </div>
    </div>
  );
};

export default Profile;
